<template>
    <v-card class="rounded mb-6" :loading="loading" :loader-height="4">
        <!-- KPI section -->
        <div class="px-6 pt-4 pb-2">
            <p class="text-medium-grey font-bold text-xl mb-3">{{ title }}</p>
            <div class="grid grid-cols-2 lg:grid-cols-5 gap-3">
                <div class="bg-grey rounded px-4 py-3">
                    <v-label class="text-sm uppercase font-bold mb-1">Configurări</v-label>
                    <p class="text-3xl text-black font-bold mb-0">{{ configs }}</p>
                </div>

                <div class="bg-grey rounded px-4 py-3">
                    <v-label class="text-sm uppercase font-bold mb-1">Oferte întocmite</v-label>
                    <p class="text-3xl text-black font-bold mb-0">{{ offers }}</p>
                </div>

                <div class="bg-grey rounded px-4 py-3">
                    <v-label class="text-sm uppercase font-bold mb-1">Contracte</v-label>
                    <p class="text-3xl text-black font-bold mb-0">{{ contracts }}</p>
                </div>

                <div class="bg-grey rounded px-4 py-3">
                    <v-label class="text-sm uppercase font-bold mb-1">
                        Oferte
                        <v-icon dense color="grey">mdi-arrow-right</v-icon>
                        Contracte
                    </v-label>
                    <p class="text-3xl font-bold mb-0" :class="rateColor(pctContractsOffers)">
                        {{ pctContractsOffers }}%
                    </p>
                </div>

                <div class="bg-grey rounded px-4 py-3">
                    <v-label class="text-sm uppercase font-bold mb-1">
                        Configurări
                        <v-icon dense color="grey">mdi-arrow-right</v-icon>
                        Contracte
                    </v-label>
                    <p class="text-3xl font-bold mb-0" :class="rateColor(pctContractsConfigs)">
                        {{ pctContractsConfigs }}%
                    </p>
                </div>
            </div>
        </div>

        <v-divider class="mx-4 my-4"></v-divider>

        <!-- Funnel section -->
        <div class="px-6 pb-4">
            <p class="text-medium-grey font-bold text-xl mb-3">Conversii</p>
            <div class="flex items-center justify-center">
                <div class="funnel-stage bg-blue-50 border border-blue-200 rounded px-5 py-3 text-center min-w-32">
                    <p class="text-sm uppercase text-medium-grey font-bold mb-1">Configurări</p>
                    <p class="text-2xl font-bold text-blue-700 mb-0">{{ configs }}</p>
                </div>

                <div class="flex flex-col items-center px-3">
                    <span class="text-base font-bold mb-1" :class="rateColor(pctOffersConfigs)">
                        {{ pctOffersConfigs }}%
                    </span>
                    <v-icon color="grey lighten-1">mdi-arrow-right</v-icon>
                </div>

                <div class="funnel-stage bg-orange-50 border border-orange-200 rounded px-5 py-3 text-center min-w-32">
                    <p class="text-sm uppercase text-medium-grey font-bold mb-1">Oferte emise</p>
                    <p class="text-2xl font-bold mb-0" style="color: #ff8635;">{{ offers }}</p>
                </div>

                <div class="flex flex-col items-center px-3">
                    <span class="text-base font-bold mb-1" :class="rateColor(pctContractsOffers)">
                        {{ pctContractsOffers }}%
                    </span>
                    <v-icon color="grey lighten-1">mdi-arrow-right</v-icon>
                </div>

                <div class="funnel-stage bg-green-50 border border-green-200 rounded px-5 py-3 text-center min-w-32">
                    <p class="text-sm uppercase text-medium-grey font-bold mb-1">Contracte</p>
                    <p class="text-2xl font-bold text-green-700 mb-0">{{ contracts }}</p>
                </div>
            </div>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'FunnelKPIs',
    props: {
        title: { type: String, default: 'Rezumat - toti agentii' },
        configs: { type: Number, default: 0 },
        offers: { type: Number, default: 0 },
        contracts: { type: Number, default: 0 },
        loading: { type: Boolean, default: false },
    },
    computed: {
        pctOffersConfigs() {
            return this.configs > 0 ? parseFloat(((this.offers / this.configs) * 100).toFixed(1)) : 0;
        },
        pctContractsOffers() {
            return this.offers > 0 ? parseFloat(((this.contracts / this.offers) * 100).toFixed(1)) : 0;
        },
        pctContractsConfigs() {
            return this.configs > 0 ? parseFloat(((this.contracts / this.configs) * 100).toFixed(1)) : 0;
        },
    },
    methods: {
        rateColor(pct) {
            if (pct >= 15) return 'text-green-600';
            if (pct >= 10) return 'text-blue-500';
            return 'text-gray-500';
        },
    },
}
</script>
